import {
    getAxios,
} from './axios'

export function getCgu() {
    let axios = getAxios();

    // axios.interceptors.response.use(profileResponseInterceptor);

    return axios.request({
        url: "/cgu/",
        method: 'get'
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/cgu.js